import { render, staticRenderFns } from "./OneColorBar.vue?vue&type=template&id=837c75d6&scoped=true&lang=pug"
import script from "./OneColorBar.vue?vue&type=script&lang=js"
export * from "./OneColorBar.vue?vue&type=script&lang=js"
import style0 from "./OneColorBar.vue?vue&type=style&index=0&id=837c75d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "837c75d6",
  null
  
)

export default component.exports